import { TeamId } from '@/react/portainer/users/teams/types';
import { UserId } from '@/portainer/users/types';
import { Directive } from '@/react/portainer/policies/types';
import { UnifiedAccess } from '@/react/portainer/policies/components/docker/rbac/types';

/**
 * Unified access entry for Kubernetes RBAC policies
 * Represents user or team with role and optional namespaces (for namespace-scoped roles)
 */
export interface KubernetesUnifiedAccess extends UnifiedAccess {
  /** Namespaces this access applies to (for namespace-scoped roles only) */
  namespaces?: string[];
}

/**
 * Form data for Kubernetes RBAC Policy
 */
export interface KubernetesRbacFormValues {
  /** Policy name */
  name: string;
  /** Environment group IDs to apply this policy to */
  environmentGroupIds: Array<number>;
  /** List of user/team access entries */
  accessList: KubernetesUnifiedAccess[];
}

/**
 * Access policy value structure for backend
 * Unwrapped inner structure (Directive wrapper applied at policy level)
 */
export interface KubernetesAccessPolicyValue {
  RoleId: number;
  Namespaces?: string[];
}

/**
 * API payload for Kubernetes RBAC Policy
 * All users/teams are in EnvironmentAccessPolicies; namespace-scoped roles include Namespaces in their policy value
 */
export interface KubernetesRbacPolicyPayload {
  EnvironmentAccessPolicies: {
    UserAccessPolicies: Record<UserId, Directive<KubernetesAccessPolicyValue>>;
    TeamAccessPolicies: Record<TeamId, Directive<KubernetesAccessPolicyValue>>;
  };
}

/**
 * Default initial values for Kubernetes RBAC Policy (create mode)
 */
export const KUBERNETES_RBAC_INITIAL_VALUES: KubernetesRbacFormValues = {
  name: '',
  environmentGroupIds: [],
  accessList: [],
};
